import { PageContainer } from "../../../../components/common/page-container";
import { Heading } from "../../../../components/common/typography";
import { ShimmerLoader, Shimmer } from "../../../../components/common/shimmer/shimmer";
import { useLoyaltyConfig } from "../../hooks/useLoyaltyConfig";
import { LoyaltyConfigPreview } from "../components/loyalty-config-preview";
import { LoyaltyConfigForm } from "../components/loyalty-config-form";

/** Admin loyalty points configuration: current values + update form. */
export function AdminLoyaltySettingsPage() {
  const { data: config, isLoading } = useLoyaltyConfig();

  return (
    <PageContainer>
      <div className="flex flex-col gap-6">
        <Heading variant="h2" tone="dark">
          Loyalty Points Configuration
        </Heading>

        {isLoading || !config ? (
          <ShimmerLoader message="Loading loyalty configuration…">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <Shimmer className="h-56 rounded-xl" />
              <Shimmer className="h-56 rounded-xl" />
            </div>
          </ShimmerLoader>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <LoyaltyConfigPreview config={config} />
            <div className="rounded-xl border border-borderDefault bg-bgWhite px-6 py-5 flex flex-col gap-4 max-sm:px-4">
              <Heading variant="h3" tone="dark" className="pb-4 border-b border-borderDefault">
                Update Configuration
              </Heading>
              <LoyaltyConfigForm config={config} />
            </div>
          </div>
        )}
      </div>
    </PageContainer>
  );
}
